import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapperVW'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { vwSize } from 'src/utils/vwCss'
// vw指定に変更したので別ファイルに
import { PointCard } from 'src/components/molecules/PointCardNew'
import { PointCardLayout } from 'src/components/molecules/PointCardLayout'
import { Typography } from 'src/components/atoms/Typography'
// image
import BGAbout from 'src/images/top/about/bg.png'

const points = [
  {
    number: '01',
    imageName: 'communication',
    title: '既存ユーザーの\n ロイヤリティ・売上向上',
    description: false,
    feature: [
      '顧客の疑問・悩みが解消',
      '良質な情報が蓄積',
      '顧客同士のコミュニケーション'
    ]
  },
  {
    number: '02',
    imageName: 'interactive',
    title: 'インサイト発掘',
    description: false,
    feature: [
      '帰属意識の醸成',
      '顧客の生の声が集約'
    ]
  },
  {
    number: '03',
    imageName: 'data',
    title: '新規顧客獲得',
    description: false,
    feature: [
      'UGC(顧客主導のコンテンツ)発生',
      '顧客からの紹介発生',
      'コミュニティ自体のPRコンテンツ化'
    ]
  }
]

const TopAbout = ({top}) => {
  const data = useStaticQuery(graphql`
    query {
      communication: file(relativePath: { eq: "top/about/feature1.svg" }) {
        publicURL
      }
      interactive: file(relativePath: { eq: "top/about/feature2.svg" }) {
        publicURL
      }
      data: file(relativePath: { eq: "top/about/feature3.svg" }) {
        publicURL
      }
      customerSuccess: file(relativePath: { eq: "top/about/customer_success.svg" }) {
        publicURL
      }
    }
  `)

  return (
    <Container>
      <ContentsWrapper>
        <FadeDownWrap>
          <HeadingBorder heading="ABOUT" />
        </FadeDownWrap>
        <FadeDownWrap>
          <HeadTitle as="h2" className={"g-h2"}>
            <NoLineBreak>commmuneが</NoLineBreak>
              <NoLineBreak>{top ? "提供する価値" : "選ばれる理由"}</NoLineBreak>
          </HeadTitle>
        </FadeDownWrap>
        <FadeDownWrap>
          <PointCardGridLayoutWrapper>
            <PointCardLayout skip2column>
              {points.map(point => {
                const { publicURL } = data[point.imageName]
                return (
                  <PointCard
                    key={point.imageName}
                    {...point}
                    imageUrl={publicURL}
                    feature={point.feature}
                  />
                )
              })}
            </PointCardLayout>
          </PointCardGridLayoutWrapper>
        </FadeDownWrap>
        {top &&
          <FadeDownWrap>
            <FeaturedPointWrapper>
              <FeaturedPointMessage>
                <HeadTitle as="h3" className={"g-h2"} css={FeaturedPointTitle}>
                  カスタマーサクセスの<br />強力な支援
                </HeadTitle>
                <FeaturedPointDescription>
                  実績に裏打ちされたカスタマーサクセスが運用を支援。
                </FeaturedPointDescription>
                <FeaturedPointDescription>
                  コミュニティ施策の成功率を最大化するために、<br className={"sp-none"} />
                  パートナーとして戦略検討から運用サポートまで伴走します。
                </FeaturedPointDescription>
              </FeaturedPointMessage>
              <FeaturedPointImageWrapper>
                <FeaturedPointImage src={data.customerSuccess.publicURL} alt="" />
              </FeaturedPointImageWrapper>
            </FeaturedPointWrapper>
          </FadeDownWrap>
        }
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.section`
  background-image: url(${BGAbout});
  background-repeat; no-repeat;
  background-position; center bottom;
  background-size: cover;
  width: 100%;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    background-size: 400vw auto;
    background-repeat; no-repeat;
    background-position; center bottom;
    background-size: cover;
  }
`
const PointCardGridLayoutWrapper = styled.div`
  margin: ${Styles.spacing[11]} 0 0;
  @media screen and (min-width: ${BreakPoint.MOBILE_L}) {
    margin: 0;
  }
`

const FeaturedPointTitle = css`
  margin-bottom: ${vwSize(40, 'pc')}vw !important;
`

const FeaturedPointWrapper = styled.div`
  padding: ${vwSize(48, 'pc')}vw ${vwSize(64, 'pc')}vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${vwSize(80, 'pc')}vw 0 0;
  box-sizing: border-box;
  border-radius: ${Styles.pc.borderRadiusL};
  background: ${Styles.color.grayscale[100]};
  filter: drop-shadow(8px 8px 20px rgba(112, 181, 197, 0.15));
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin: ${vwSize(64, 'sp')}vw 0 0;
    border-radius: ${Styles.sp.borderRadiusL};
    flex-direction: column;
  }
`

const FeaturedPointMessage = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;
  font-size: ${Styles.pc.fontSize.text};
  margin: ${vwSize(32, 'pc')}vw 0 0;
  max-width: ${vwSize(488, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.text};
    max-width: 100%;
    margin: ${vwSize(32, 'sp')}vw 0 0;
  }
`

const FeaturedPointDescription = styled(Typography)`
  margin: ${Styles.spacing[7]} 0 0;
  font-size: ${Styles.pc.fontSize.text};
  line-height: ${Styles.lineHeight[350]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.text};
  }
`
const FeaturedPointImageWrapper = styled.div`
  padding: ${Styles.spacing[8]} 0 0;
  max-width: 70%;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: ${vwSize(24, 'sp')}vw 0 0;
    max-width: none;
  }
`

const FeaturedPointImage = styled.img`
  max-width: 100%;
  height: auto;
`

export default TopAbout
